import React from 'react';
import cx from 'classnames';
import Tippy from '@tippyjs/react';

import { ChangeTypes } from 'app/types/info-tabs';
import Dynamics from 'app/components/ui/Dynamics';
import { ReactComponent as Warning } from 'app/components/svg/Warning.svg';

import s from './DynamicsWithTooltip.module.sass';

type DynamicsWithTooltipProps = {
  change?: ChangeTypes
  className?: string
  xtzOnly?: boolean
};

const DynamicsWithTooltip: React.FC<DynamicsWithTooltipProps> = ({
  change,
  className,
  xtzOnly,
}) => (
  <Tippy
    content={(
      <div className={cx(s.tooltip)}>
        <div className={cx(s.wrapper)}>
          <span>24 h</span>
          <span className={cx(s.separetor)}>:</span>
          <Dynamics dynamics={change ? change.day : 'inf'} className={cx(s.dynamics)} />
        </div>

        <div className={cx(s.wrapper)}>
          <span className={s.offset}>7 d</span>
          <span className={cx(s.separetor)}>:</span>
          <Dynamics dynamics={change ? change.week : 'inf'} className={cx(s.dynamics)} />
        </div>

        <div className={cx(s.wrapper)}>
          <span>30 d</span>
          <span className={cx(s.separetor)}>:</span>
          <Dynamics dynamics={change ? change.month : 'inf'} className={cx(s.dynamics)} />
        </div>

        {xtzOnly && (
          <div className={cx(s.warning)}>
            <Warning className={cx(s.icon)} />
            Relative to XTZ
          </div>
        )}
      </div>
    )}
    placement="bottom-end"
    duration={0}
    appendTo={() => document.querySelector('#baseLayout') || document.body}
    interactive
  >
    <div
      className={cx(s.root, className)}
    >
      <Dynamics dynamics={change ? change.day : 'inf'} className={cx(s.area)} />
    </div>
  </Tippy>
);

export default DynamicsWithTooltip;
